/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';

const $root = ($protobuf.roots['default']|| ($protobuf.roots['default'] = new $protobuf.Root()));

$root.addJSON({
  "squareup": {
    "nested": {
      "billing": {
        "nested": {
          "data": {
            "nested": {
              "SubscriptionFeeBillCycle": {
                "values": {
                  "UNKNOWN": 0,
                  "PREPAY_MONTHLY": 1,
                  "FREE": 2,
                  "PAY_AS_YOU_GO_MONTHLY": 3,
                  "PAY_AS_YOU_GO": 4,
                  "POSTPAY_MONTHLY": 5,
                  "ONE_TIME": 6,
                  "PREPAY_YEARLY": 7,
                  "MIXED_PAY_YEARLY": 8
                }
              }
            }
          }
        }
      }
    }
  }
});

/**
 * The billing cycle for a given line item.  Used by reconciliation.
 *
 * SOURCE SubscriptionFeeBillCycle @ squareup/billing/data.proto at 31:1
 */
export const SubscriptionFeeBillCycle = $root.lookupEnum('squareup.billing.data.SubscriptionFeeBillCycle').values;
